import * as menu from "@/api/menu.js";

export default {
  state: {
    menu: "Map",
    category: [],
    itemMasterList: [],
    favoriteItemList: [],
    alert: null,
    landUsePlanHideLabel: [], // 토지이용계획도 특정 범례 라벨 숨기기

    // 상세정보 상, 기본정보 표기여부
    isSystemData: false,
  },
  getters: {
    getMenu: (state) => state.menu,
    getCategory: (state) => state.category,
    getItemMasterList: (state) => state.itemMasterList,
    getFavoriteItemList: (state) => state.favoriteItemList,
    getAlert: (state) => state.alert,
    getLandUsePlanHideLabel: (state) => state.landUsePlanHideLabel,

    // 상세정보 상, 기본정보 표기여부
    getIsSystemData: (state) => state.isSystemData,
  },
  mutations: {
    SET_MENU(state, payload) {
      state.menu = payload;
    },
    SET_CATEGOTY(state, payload) {
      state.category = payload;
    },
    SET_ITEMMASTER_LIST(state, payload) {
      state.itemMasterList = payload;
    },
    SET_FAVORITE_LIST(state, payload) {
      state.favoriteItemList = payload;
    },
    SET_ALERT(state, payload) {
      state.alert = payload;
    },
    SET_SUCCESS(state, payload) {
      /**
        {
          title: "정상적으로 등록되었습니다.",
          closeIn: 5000 (default= 3000) // 5 초뒤 사라짐
        }
      **/
      payload.type = "SUCCESS";
      state.alert = payload;
    },
    SET_ERROR(state, payload) {
      payload.type = "ERROR";
      state.alert = payload;
    },
    SET_INFO(state, payload) {
      payload.type = "INFO";
      state.alert = payload;
    },

    SET_LAND_USE_PLAN_HIDE_LABEL(state, payload) {
      if (payload.type === "ALL") {
        state.landUsePlanHideLabel = [];
        for (var i = 0; i < payload.val.length; i++) {
          state.landUsePlanHideLabel.push(payload.val[i]);
        }
      } else if (payload.type === "EMPTY") {
        state.landUsePlanHideLabel = [];
      } else {
        const index = state.landUsePlanHideLabel.findIndex(
          (item) => item === payload.val
        );
        if (index > -1) {
          state.landUsePlanHideLabel.splice(index, 1);
        } else {
          state.landUsePlanHideLabel.push(payload.val);
        }
      }
    },
    SET_IS_SYSTEM_DATA(state, payload) {
      state.isSystemData = payload;
    },
  },
  actions: {
    getMenuCategory({ commit }, payload) {
      menu
        .getCategory(payload)
        .then((res) => {
          commit("SET_CATEGOTY", res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getItemList({ commit }) {
      menu
        .getItemList()
        .then((res) => {
          commit("SET_ITEMMASTER_LIST", res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFavorite({ commit }) {
      menu
        .getFavorite()
        .then((res) => {
          // console.log(res);
          commit("SET_FAVORITE_LIST", res.data);
          var itemList = [];
          for (var i = 0; i < res.data.length; i++) {
            itemList.push(res.data[i].item);
          }
          commit("SET_FAVORITE_LAYER_IDS", itemList);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
